/* RD Customz — collection + search page module.
   Filter panel (off-canvas on phones: dialog semantics, focus trap, Esc; sidebar on desktop) and in-place facet updates through the
   Section Rendering API. The underlying GET form and links keep working without JavaScript. */
const { RDC, track, announce, trapFocus, setBackgroundInert } = window.rdc;

const root = document.querySelector('[data-rdc-collection]');
const panel = document.querySelector('[data-rdc-panel]');
const mq = matchMedia('(min-width: 1024px)');
let opener = null;

function openPanel(trigger) {
  if (!panel || mq.matches) return;
  opener = trigger;
  panel.dataset.open = 'true';
  panel.setAttribute('role', 'dialog');
  panel.setAttribute('aria-modal', 'true');
  document.documentElement.classList.add('rdc-lock');
  setBackgroundInert(panel, true);
  panel.querySelectorAll('input,select,button,a[href]')[1]?.focus();
}
function closePanel() {
  if (!panel || panel.dataset.open !== 'true') return;
  panel.dataset.open = 'false';
  panel.removeAttribute('role');
  panel.removeAttribute('aria-modal');
  document.documentElement.classList.remove('rdc-lock');
  setBackgroundInert(panel, false);
  if (window.location.hash === '#rdc-filters') history.replaceState(history.state, '', window.location.pathname + window.location.search);
  opener?.focus();
}

document.addEventListener('click', (e) => {
  const open = e.target.closest('[data-rdc-panel-open]');
  if (open) { e.preventDefault(); openPanel(open); return; }
  if (e.target.closest('[data-rdc-panel-close]')) { e.preventDefault(); closePanel(); }
});
panel?.addEventListener('keydown', (e) => {
  if (panel.dataset.open !== 'true') return;
  if (e.key === 'Escape') { e.preventDefault(); closePanel(); }
  trapFocus(panel, e);
});

/* ------------------------------------------------------------ in-place facet updates */
// sub-collection row (rdc-subcollection-nav): bring the current car make into view, horizontally only (never scrolls the page)
document.querySelectorAll('[data-rdc-subnav]').forEach((list) => {
  const cur = list.querySelector('[aria-current="page"]');
  if (!cur || list.scrollWidth <= list.clientWidth) return;
  list.scrollLeft += cur.getBoundingClientRect().left - list.getBoundingClientRect().left - parseFloat(getComputedStyle(list).paddingLeft);
});

const sectionId = root && (root.closest('.shopify-section')?.id || '').replace(/^shopify-section-/, '');
let controller = null;
let timer = null;

async function load(url, { push = true } = {}) {
  if (!sectionId) { window.location.href = url; return; }
  controller?.abort();
  controller = new AbortController();
  const fetchUrl = new URL(url, window.location.origin);
  fetchUrl.searchParams.set('section_id', sectionId);
  root.setAttribute('aria-busy', 'true');
  try {
    const html = await (await fetch(fetchUrl, { signal: controller.signal })).text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const freshResults = doc.querySelector('[data-rdc-results]');
    const results = root.querySelector('[data-rdc-results]');
    if (freshResults && results) results.innerHTML = freshResults.innerHTML;
    const freshForm = doc.querySelector('[data-rdc-facets] .rdc-filters__body');
    const body = root.querySelector('[data-rdc-facets] .rdc-filters__body');
    if (freshForm && body) {
      const active = document.activeElement && document.activeElement.id;
      body.innerHTML = freshForm.innerHTML;
      if (active) document.getElementById(active)?.focus({ preventScroll: true });
    }
    const freshSubmit = doc.querySelector('[data-rdc-facets-submit]');
    const submit = root.querySelector('[data-rdc-facets-submit]');
    if (freshSubmit && submit) submit.textContent = freshSubmit.textContent;
    if (push) history.replaceState(history.state, '', url);
    const count = root.querySelector('[data-rdc-count]');
    announce(count ? count.textContent : RDC.strings.resultsUpdated);
  } catch (err) {
    if (err.name !== 'AbortError') window.location.href = url;
  } finally {
    root.removeAttribute('aria-busy');
  }
}

function formUrl(form) {
  const params = new URLSearchParams();
  new FormData(form).forEach((value, key) => { if (value !== '') params.append(key, value); });
  return `${form.getAttribute('action') || window.location.pathname}?${params.toString()}`;
}

if (root) {
  root.addEventListener('change', (e) => {
    const input = e.target.closest('[data-rdc-facet-input]');
    if (!input) return;
    const form = input.form;
    clearTimeout(timer);
    timer = setTimeout(() => {
      load(formUrl(form));
      track('filter_applied', { filter_type: input.name, value: input.type === 'checkbox' ? input.value : 'range' });
    }, input.type === 'number' ? 500 : 150);
  });
  root.addEventListener('submit', (e) => {
    const form = e.target.closest('[data-rdc-facets]');
    if (!form) return;
    e.preventDefault();
    load(formUrl(form)).then(closePanel);
  });
  root.addEventListener('click', (e) => {
    const link = e.target.closest('[data-rdc-facet-link]');
    if (!link) return;
    e.preventDefault();
    load(link.href);
    track('filter_removed', {});
  });
}
